"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Alert = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  height: '100dvh',
  overflowY: 'scroll',
  padding: theme.spacing(0, 3),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(0, 6)
  }
}));
const Alert = exports.Alert = (0, _mui.styled)(_mui.Alert)(({
  theme
}) => ({
  margin: theme.spacing(3, 0)
}));